import * as Types from '../../../__generated__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteShoppableProductMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeleteShoppableProductMutation = { __typename?: 'RootMutationType', deleteShoppableProduct?: { __typename?: 'ActionResult', userErrors?: Array<{ __typename?: 'UserError', field: string, message: string }> | null } | null };


export const DeleteShoppableProductDocument = gql`
    mutation deleteShoppableProduct($id: ID!) {
  deleteShoppableProduct(id: $id) {
    userErrors {
      field
      message
    }
  }
}
    `;
export type DeleteShoppableProductMutationFn = Apollo.MutationFunction<DeleteShoppableProductMutation, DeleteShoppableProductMutationVariables>;

/**
 * __useDeleteShoppableProductMutation__
 *
 * To run a mutation, you first call `useDeleteShoppableProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteShoppableProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteShoppableProductMutation, { data, loading, error }] = useDeleteShoppableProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteShoppableProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteShoppableProductMutation, DeleteShoppableProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteShoppableProductMutation, DeleteShoppableProductMutationVariables>(DeleteShoppableProductDocument, options);
      }
export type DeleteShoppableProductMutationHookResult = ReturnType<typeof useDeleteShoppableProductMutation>;
export type DeleteShoppableProductMutationResult = Apollo.MutationResult<DeleteShoppableProductMutation>;
export type DeleteShoppableProductMutationOptions = Apollo.BaseMutationOptions<DeleteShoppableProductMutation, DeleteShoppableProductMutationVariables>;